import React from 'react'
import styled from 'styled-components'
import { BackgroundImage, Box, Button, Link, Text } from 'pcln-design-system'
import { send } from '../../../utils//PCLN-Analytics'

const { PUBLIC_URL = '/home/public/' } = process.env

const handleClick = (event: MouseEvent) => {
  event.preventDefault()
  send({
    category: 'PCLN_HOME',
    action: 'Click',
    data: 'Roadtrip Promo'
  })
  window.location.assign('/trips')
}

const StyledLink = styled(Link)`
  &:hover {
    text-decoration: none;
  }
`

const Wrapper = styled(BackgroundImage)`
  border-radius: 4px;
`

const StyledText = styled(Text)`
  width: 174px;
`

const MobileRoadTripPromo: React.FC = props => (
  <Box mt={24}>
    <StyledLink
      mt={24}
      onClick={handleClick}
      target='_self'
      {...props}
    >
      <Wrapper
        height='136px'
        width={1}
        image={`${PUBLIC_URL}assets/images/promos/road-trip-mobile.jpg`}
      >
        <Box py={3} pl={3}>
          <StyledText
            bold
            fontSize={2}
            lineHeight={1.4}
            color='text'
          >
            Planning a roadtrip or local getaway?
          </StyledText>
        </Box>
        <Box pl={3}>
          <Button size='small' width='106px'>Search Deals</Button>
        </Box>
      </Wrapper>
    </StyledLink>
  </Box>
)

export default MobileRoadTripPromo
